import React, { useState } from "react";

const faqList = [
  {
    id: 0,
    title: "How does Loana work?",
    content:
      "Loana is a loan web application that offers both personal and business loans to all it’s users. we also offer lorem lorem lorem",
  },
  {
    id: 1,
    title: "What interest rates can I expect on the loans?",
    content:
      "The interest rates vary depending on your credit score and loan type.",
  },
  {
    id: 2,
    title: "What happens if I miss a loan payment?",
    content:
      "Missing a payment may result in a late fee or affect your credit score.",
  },
  {
    id: 3,
    title: "Is my personal information safe?",
    content:
      "Yes, your information is protected using state-of-the-art encryption.",
  },
  {
    id: 4,
    title: "Do I really get monthly payments on my savings?",
    content: "Yes, our savings accounts offer monthly interest payments.",
  },
  {
    id: 5,
    title: "What are the interest rates on my savings?",
    content:
      "Interest rates for savings accounts are competitive and vary by plan.",
  },
];

const Faq = () => {
  const [activeFaq, setactiveFaq] = useState(0);

  return (
    <div className="flex flex-col lg:flex-row items-start space-y-4 lg:space-y-0 lg:space-x-10 mt-9 *:rounded-xl">
      <div
        className="bg-loana-light hidden lg:flex flex-col justify-between py-7 px-7 w-full lg:w-1/2 h-full"
        style={{ minHeight: "a" }}
      >
        <p className="text-loana-black font-semibold text-sm tracking-wide leading-8">
          {faqList[activeFaq].content}
        </p>
        <p className="text-sub-text text-xs font-medium tracking-wide mt-12">
          {faqList[activeFaq].title}
        </p>
      </div>
      <div className="w-full lg:w-1/2 flex flex-col gap-5 *:font-semibold *:text-sm *:p-5 *:cursor-pointer *:w-full *:sm:ring-1 *:ring-inset *:ring-loana-stroke">
        {faqList.map((faq, index) => (
          <>
            <button
              key={faq.id}
              onClick={() => setactiveFaq(index)}
              className={`bg-loana-light w-full text-loana-blue rounded-xl text-left ${
                activeFaq === index ? "!bg-loana-blue text-white" : ""
              }`}
            >
              {faq.title}
            </button>
            {faq.id === activeFaq && (
              <div
                className="bg-loana-light ring-1 ring-loana-black lg:hidden flex flex-col justify-between py-7 px-7 w-full lg:w-2/3 rounded-xl"
                style={{ minHeight: "100px" }}
              >
                <p className="text-loana-black font-semibold text-sm tracking-wide leading-8">
                  {faq.content}
                </p>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default Faq;
